import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";
import BlockLinkWithImg from "./BlockLinkWithImg";

export default () => {
    const title = 'Виртальные экскурсии';

    const listEkses = [
        {
            imgFile: require('./img/virtualtours/beloeozero.jpg'),
            toLink: '/vtur-beloe-ozero',
            sub: 'Белое озеро'
        },
        {
            imgFile: require('./img/virtualtours/mulnoieozero.jpg'),
            toLink: '/vtur-mulnoie-ozero',
            sub: 'Озеро Мульное'
        },
        {
            imgFile: require('./img/virtualtours/belpuscha.jpg'),
            toLink: '/vtur-bel-puscha',
            sub: 'Беловежская пуща'
        },
        {
            imgFile: require('./img/virtualtours/museumlocomotive.jpg'),
            toLink: '/vtur-museum-locomotive',
            sub: 'Музей железнодорожной техники'
        },
        {
            imgFile: require('./img/virtualtours/lelikovokort.jpg'),
            toLink: '/vtur-lelikovo-kort',
            sub: 'Леликово. Тенисный корт'
        },
        {
            imgFile: require('./img/virtualtours/landofkosciuszko.jpg'),
            toLink: '/vtur-land-of-kosciuszko',
            sub: 'Земля Костюшко'
        },
        {
            imgFile: require('./img/virtualtours/bronnayamountain.jpg'),
            toLink: '/vtur-bronnay-amountain',
            sub: 'Бронная гора'
        },
        {
            imgFile: require('./img/virtualtours/andreytadeuszkosciuszko.jpg'),
            toLink: '/vtur-andrey-tadeusz-kosciuszko',
            sub: 'Андрей Тадеуш Костюшко'
        },
    ];

    let viewListEkses = listEkses.map((item, index) => {
            return (
                <BlockLinkWithImg
                    key = {index}
                    toLink = {item.toLink}
                    imgFile = {item.imgFile}
                    sub = {item.sub}
                />
            );
        }
    );

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {viewListEkses}
                </div>
            </div>
        </>
    );
}